<template>
  <header>
    <nav class="bg-white border-gray-200 shadow-md dark:bg-gray-800 overflow-hidden z-50 absolute w-full">
      <div
        class="flex items-center justify-center lg:justify-start lg:w-auto lg:order-1 border-b-2 border-gray-300 dark:border-gray-700 py-5 px-5"
        id="mobile-menu-2"
      >
        <a :href="$url('/')" class="flex items-center">
          <img
            v-if="branchLogoUrl"
            :src="branchLogoUrl"
            alt="Branch Logo"
            class="w-40"
          />
          <img
            v-else-if="instanceLogoUrl"
            :src="instanceLogoUrl"
            alt="Instance Logo"
            class="w-40"
          />
          <img src="/img/jamLMS-logo.png" class="w-40" v-else />
        </a>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  props: {
    branch: {
      type: Object,
      default: () => null,
    },
    instance: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    branchLogoUrl() {
      return this.branch && this.branch.logo_url
        ? `${process.env.VUE_APP_API_URL}${this.branch.logo_url}`
        : null;
    },
    instanceLogoUrl() {
      return this.instance && this.instance.logo_url
        ? `${process.env.VUE_APP_API_URL}${this.instance.logo_url}`
        : null;
    },
  },
};
</script>
